export default "__VITE_ASSET__VeMyvsVu__"